module.exports = __webpack_public_path__ + "img/partner.a3f17ac8.png";